// extracted by mini-css-extract-plugin
module.exports = {"size":"IconArrowDown_size__vFI0r"};